<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { reactive, ref, watch } from 'vue'
import useVuelidate from '@vuelidate/core'
import Checkbox from '@/components/input/Checkbox.vue'
import TextAreaField from '@/components/input/TextAreaField.vue'
import { maxLength } from '@/validation'

const props = defineProps<{
  disabled?: boolean
}>()
const model = defineModel<string | null>()

const { t } = useI18n()

const enabled = ref(false)
const state = reactive({ text: '' })
const validation = useVuelidate<{ text: string }>({ text: { maxLength: maxLength(5000) } }, state)

let emitted: string | null | undefined
watch(
  model,
  (value) => {
    if (value === emitted) return
    enabled.value = !!value
    state.text = value ?? ''
  },
  { immediate: true },
)

function sync() {
  emitted = enabled.value && state.text.trim() ? state.text : null
  model.value = emitted
}

function toggle(value: boolean) {
  enabled.value = value
  sync()
}

function updateText(value: string) {
  state.text = value
  sync()
}
</script>

<template>
  <checkbox
    :model-value="enabled"
    :label="t('entity.step.field.warning')"
    :disabled="props.disabled"
    @update:model-value="toggle"
  />
  <text-area-field
    v-if="enabled"
    :model-value="state.text"
    :label="t('entity.step.field.warningText')"
    :validation="validation.text"
    :disabled="props.disabled"
    rows="2"
    auto-grow
    @update:model-value="updateText"
  />
</template>
